export default __webpack_public_path__ + "locales/pt/Payments.json?hash=e8053d3596f319391d3c2b21ae729852";